import { NativeActionsList } from '@wix/editor-platform-host-integration-apis';
import { ContributedPlatformActionsDict } from '../types';
import { presetsActionFactory } from './presetsActionFactory';
import { elementsPanelActionFactory } from './elementsPanelActionFactory';
import { editTextPanelActionFactory } from './editTextPanelActionFactory';

export const platformNativeActions: ContributedPlatformActionsDict = {
  [NativeActionsList.presets]: presetsActionFactory,
  [NativeActionsList.elements]: elementsPanelActionFactory,
  [NativeActionsList.editText]: editTextPanelActionFactory,
};
